import React, { useRef } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Typo, useLazyLoadImage } from 'tmt-ui-kit';

import { path } from '../../../../utils/media';

const CardContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 0 -0.5rem;
  @media (max-width: 600px) {
    flex-wrap: nowrap;
    overflow-x: scroll;
  }
`;

const Header = styled(Typo.HeaderTwo)`
  height: 35px;
  margin-bottom: 8px !important;
`;

const ImageOuterContainer = styled.div`
  position: relative;
  flex-shrink: 0;
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
  margin: 0 0.5rem 1rem 0.5rem;

  width: 180px;
  @media (max-width: 423px) {
    width: 45%;
  }
  @media (max-width: 600px) {
    width: 67%;
  }

  &::after {
    content: "";
    display: block;
    padding-bottom: 125%;
  }
`;

const ImageContainer = styled.img`
  position: absolute;
  top: 0;
  bottom: 0px;
  width: 100%;
  display: block;
  opacity: 0;
  min-height: 1px;
  transition: ${props => props.theme.imageTransition};
`;

const Gradient = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  background-image: linear-gradient(0deg, #2b3940 0%, #2b3940 50%, #2b394000 100%);

  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 30px;
  padding: 0 12px;
  border-radius: 0 0 12px 12px;
`;

const TextContent = styled(Typo.Paragraph)`
  color: ${props => props.theme.white} !important;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
`;

// const TextBlock = styled.div`
// `;

const CardImage = (props) => {
  const { openGallery, isVideo, image, caption, index } = props;
  // const { path } = context;
  const ref = useRef();
  useLazyLoadImage(ref);
  return (
    <ImageOuterContainer>
      <ImageContainer
        ref={ref}
        onClick={() => openGallery(isVideo ? index + 1 : index)}
        data-src={image && path(image, 'masterGalleryCard', false, true)}
        alt={caption}
      />
      {caption && (
        <Gradient>
          <TextContent>{caption}</TextContent>
        </Gradient>
      )}
    </ImageOuterContainer>
  );
};

CardImage.contextTypes = {
  path: PropTypes.func,
};

const CardGallery = (props) => {
  const { dataGallery, openGallery, isVideo } = props;
  return (
    <div>
      <Header>Explore This Trip</Header>
      <CardContainer>
        {dataGallery.map((data, index) => {
          return (
            <CardImage
              isVideo={isVideo}
              openGallery={openGallery}
              image={data.image}
              caption={data.caption}
              index={index}
              key={`${data.image}_${data.caption}_${index}`}
            />
          );
        })}
      </CardContainer>
    </div>
  );
};

CardGallery.propTypes = {
  dataGallery: PropTypes.array,
  openGallery: PropTypes.func,
  isVideo: PropTypes.bool
};

export default CardGallery;
